import { isAUS, isISR } from '../../../../helpers/countriesHelpers';

export const getRatesAndRulesFeatureFlag = () => isAUS() || isISR();
